<template>
  <div>
    <!-- หน้าหลัก -->
    <b-modal
      v-model="modalShow"
      :title="$t('fixdetailstitle')"
      size="xl"
      @hidden="handleClose"
    >
      <div
        v-if="fix"
      >
        <div class="form-section">
          <h5 class="section-title">
            {{ $t('fixinfo') }}
          </h5>
          <div class="form-row">
            <b-form-group :label="$t('placeholderOrderFix')">
              <b-form-input
                :value="fix.order"
                class="input-box"
                disabled
              />
            </b-form-group>
            <b-form-group :label="$t('fixDate')">
              <b-form-input
                :value="formatDate(fix.timefix)"
                class="input-box"
                disabled
              />
            </b-form-group>
            <b-form-group :label="$t('cate')">
              <b-form-input
                :value="fix.category ? fix.category.nameCate : ''"
                class="input-box"
                disabled
              />
            </b-form-group>
            <b-form-group :label="$t('subcate')">
              <b-form-input
                :value="fix.subcategory ? fix.subcategory.name : ''"
                class="input-box"
                disabled
              />
            </b-form-group>
            <b-form-group :label="$t('locationname')">
              <b-form-input
                :value="fix.location ? fix.location.locationName : ''"
                class="input-box"
                disabled
              />
            </b-form-group>
			 <b-form-group :label="$t('sn')">
              <b-form-input
                :value="fix.sn || ''"
                class="input-box"
                disabled
              />
            </b-form-group>
          </div>
        </div>

        <div class="form-container">
          <div class="form-section">
            <h5 class="section-title">
              {{ $t('userinfo') }}
            </h5>
            <div class="form-row">
              <b-form-group :label="$t('user')">
                <b-form-input
                  :value="fix.user ? fix.user.username : ''"
                  class="input-box"
                  disabled
                />
              </b-form-group>
              <b-form-group :label="$t('worker')">
                <b-form-input
                  :value="fix.workerId ? fix.workerId.username : ''"
                  class="input-box"
                  disabled
                />
              </b-form-group>
              <b-form-group :label="$t('operator')">
                <b-form-input
                  :value="fix.operator"
                  class="input-box"
                  disabled
                />
              </b-form-group>
			  <b-form-group :label="$t('phone')">
              <b-form-input
                :value="fix.phone || ''"
                class="input-box"
                disabled
              />
            </b-form-group>
            </div>
          </div>

          <div class="form-section">
            <h5 class="section-title">
              {{ $t('operatorinfo') }}
            </h5>
            <div class="form-row">
              <b-form-group :label="$t('getfixjob')">
                <b-form-input
                  :value="fix.timefixget ? formatDate(fix.timefixget) : ''"
                  class="input-box"
                  disabled
                />
              </b-form-group>
              <b-form-group :label="$t('Expectedcompletion')">
                <b-form-input
                  :value="fix.timefixtk ? formatDate(fix.timefixtk) : ''"
                  class="input-box"
                  disabled
                />
              </b-form-group>
              <b-form-group :label="$t('fixdone')">
                <b-form-input
                  :value="fix.timefixdone ? formatDate(fix.timefixdone) : ''"
                  class="input-box"
                  disabled
                />
              </b-form-group>
              <b-form-group :label="$t('status')">
                <b-form-input
                  :value="fix.status ? fix.status.statusName : ''"
                  class="input-box"
                  disabled
                />
              </b-form-group>
            </div>
          </div>

        </div>

        <div class="form-container">
          <div class="form-section">
            <h5 class="section-title">
              {{ $t('expenseinfo') }}
            </h5>
            <div style="max-height: 200px; overflow-y: auto;">
              <b-table
                :items="displayExpensesList"
                :fields="expenseFields"
                class="mt-3"
                bordered
              >
                <!-- แสดงชื่อของหมวดหมู่หลัก -->
                <template #cell(expenseCateName)="data">
                  <span v-if="data.item.expenseCate && data.item.expenseCate.name">
                    {{ data.item.expenseCate.name }}
                  </span>
                </template>

                <template #cell(expenseSubcateName)="data">
                  <span v-if="data.item.expenseSubcate && data.item.expenseSubcate.name">
                    {{ data.item.expenseSubcate.name }}
                  </span>
                </template>

                <template #cell(cost)="data">
                  <span>
                    {{ formatCurrencyCost(data.item.cost) }}
                  </span>
                </template>

                <template #cell(sum)="data">
                  {{ formatCurrency(data.item.sum || (data.item.quantity * data.item.cost)) }}
                </template>
              </b-table>

            </div>
            <div style="font-weight: bold; margin-top: 10px;">
              {{ $t('totalcost') }}: {{ totalCost }}
            </div>
          </div>

        </div>

        <div class="form-container">
          <div class="form-section">
            <h5 class="section-title">
              {{ $t('infodetails') }}
            </h5>
            <div class="form-row">
              <b-form-group :label="$t('fixdetails')">
                <div class="info-box">
                  <div
                    v-for="(detail, index) in fix.fixDetails"
                    :key="index"
                  >
                    {{ detail.detail }}
                  </div>
                </div>
              </b-form-group>

              <b-form-group :label="$t('reasondetails')">
                <div class="info-box">
                  <div
                    v-for="(addDetail, index) in fix.fixDetailsAdditional"
                    :key="index"
                  >
                    {{ addDetail.fixdetail }}
                  </div>
                </div>
              </b-form-group>

              <b-form-group :label="$t('solution')">
                <div class="info-box">
                  <div
                    v-for="(soldetail, index) in fix.fixsolution"
                    :key="index"
                  >
                    {{ soldetail.soldetail }}
                  </div>
                </div>
              </b-form-group>

              <b-form-group :label="$t('fixcancelDetails')">
                <div class="info-box">
                  {{ fix.cancelDetails }}
                </div>
              </b-form-group>
            </div>
          </div>
        </div>

        <div class="form-section">
          <h5 class="section-title">
            {{ $t('feedbackinfo') }}
          </h5>
          <div class="form-row">
            <b-form-group>
              <span>{{ $t('feedback') }} : </span>
              <span
                v-for="index in maxStars"
                :key="index"
              >
                <b-icon
                  :icon="index <= fix.rate ? 'star-fill' : 'star'"
                  aria-hidden="true"
                  class="text-warning"
                />
              </span>
            </b-form-group>
          </div>

          <b-form-group :label="$t('reason') + ' :'">
            <div class="info-box">
              <span>{{ fix.surveyDetails }}</span>
            </div>
          </b-form-group>
        </div>

        <div>
          <!-- Spinner: แสดงขณะกำลังโหลดข้อมูล -->
          <div v-if="isLoadingImg">
            <b-spinner
              :label="$t('loading')"
              variant="grow"
            />
          </div>

          <!-- รูปภาพก่อนซ่อม -->
          <b-form-group :label="$t('image')">
            <div v-if="imageUrls.length > 0">
              <b-img
                v-for="(url, index) in imageUrls"
                :key="index"
                :src="url"
                alt="Uploaded Image"
                class="img-thumbnail mb-2"
                fluid
                @click="showImage(url)"
              />
            </div>
            <div v-else>
              {{ $t('noimage') }}
            </div>
          </b-form-group>

          <!-- แสดงไฟล์ที่ไม่ใช่รูปภาพ ของผู้แจ้งซ่อม -->
          <b-form-group
            :label="$t('files')"
            class="showfiles"
          >
            <div v-if="files && files.length > 0">
              <b-list-group>
                <b-list-group-item
                  v-for="(file, index) in files"
                  :key="index"
                >
                  <a
                    :href="file"
                    target="_blank"
                  >
                    {{ file.split('/').pop() }}
                  </a>
                </b-list-group-item>
              </b-list-group>
            </div>
            <div v-else>
              {{ $t('nofiles') }}
            </div>
          </b-form-group>

          <!-- รูปภาพหลังซ่อม -->
          <b-form-group :label="$t('imagefix')">
            <div v-if="imageUrlsDone.length > 0">
              <b-img
                v-for="(url, index) in imageUrlsDone"
                :key="index"
                :src="url"
                alt="Uploaded Image"
                class="img-thumbnail mb-2"
                fluid
                @click="showImage(url)"
              />
            </div>
            <div v-else>
              {{ $t('noimagefix') }}
            </div>
          </b-form-group>
        </div>
      </div>

      <!-- แสดงไฟล์ที่ไม่ใช่รูปภาพ ของช่าง/เเอดมิน -->
      <b-form-group
        :label="$t('filesdone')"
        class="showfiles"
      >
        <div v-if="filesdone && filesdone.length > 0">
          <b-list-group>
            <b-list-group-item
              v-for="(file, index) in filesdone"
              :key="index"
            >
              <a
                :href="file"
                target="_blank"
              >
                {{ file.split('/').pop() }}
              </a>
            </b-list-group-item>
          </b-list-group>
        </div>
        <div v-else>
          {{ $t('nofiles') }}
        </div>
      </b-form-group>

      <!-- ปุ่มปิดที่แทนที่ปุ่มของ modal -->
      <template v-slot:modal-footer>
        <b-button
          v-if="userId == 414 && !fix.confirmedByhead"
          variant="success"
          @click="showModalconfirmworker = true"
        >
          <b-icon
            icon="check-circle"
            aria-hidden="true"
            class="mr-2"
          />
          {{ $t('confirm') }}
        </b-button>

        <!-- Chat Button -->
        <b-button
          v-if="!(roles.includes('WORKER') && (fix.status.id === 1))"
          @click="openChatModal"
        >
          <b-icon
            icon="chat"
            aria-hidden="true"
            class="mr-2"
          />
          {{ $t('talk') }}
        </b-button>

        <!-- PDF Button -->
        <b-button @click="viewPdf()">
          <b-icon
            icon="file-earmark"
            aria-hidden="true"
            class="mr-2"
          />
          {{ $t('showpdf') }}
        </b-button>

        <b-button
          v-if="(roles.includes('APPROVER') || roles.includes('SYSTEM')) && fix.status.id === 1"
          variant="danger"
          style="width: 100px; min-width: 100px"
          @click="deleteFix"
        >
          {{ $t('cancel') }}
        </b-button>

        <b-button
          variant="dark"
          @click="modalShow = false"
        >
          {{ $t('close') }}
        </b-button>
      </template>

      <!-- model รูปภาพ -->
      <b-modal
        v-model="imageModalShow"
        size="lg"
        :title="$t('showimage')"
        hide-footer
        @hidden="handleImageClose"
      >
        <b-img
          :src="selectedImage"
          alt="Large Image"
          fluid
        />
      </b-modal>

      <!-- โมดัลแชท -->
      <b-modal
        v-model="chatModalShow"
        :title="$t('talk')"
        hide-footer
        size="lg"
        @hidden="clearChat"
      >
        <div class="chat-container">
          <div
            ref="messages"
            class="messages"
          >
            <div
              v-for="chat in chats"
              :key="chat.id"
              :class="{'my-message': chat.user.id == currentUserId, 'other-message': chat.user.id != currentUserId}"
            >
              <div
                v-if="chat.user.id != currentUserId"
                class="user-image-container"
              >
                <img
                  v-if="chat.user.profileImage"
                  :src="`data:image/jpeg;base64,${chat.user.profileImage}`"
                  alt="User Image"
                  class="user-image"
                >
                <span v-else>{{ $t('noimage') }}</span>
              </div>

              <div class="chat-bubble">
                <small class="user-name">
                  {{ chat.user.username || this.$t('notfoundname') }}
                </small>
                <p>{{ chat.message }}</p>
                <small class="timestamp">{{ formatDatechat(chat.timestamp) }}</small>
              </div>
            </div>
          </div>

          <!--chat fun-->
          <div class="input-group">
            <input
              v-model="message"
              :placeholder="$t('typeing')"
              @keyup.enter="sendMessage"
            >
            <button @click="sendMessage">
              {{ $t('send') }}
            </button>
          </div>
        </div>
      </b-modal>
      <b-modal
        v-model="showCancelModal"
        :title="$t('fixcancel')"
        hide-footer
        @hidden="clearCancelDetails"
      >
        <div>
          <b-form-group :label="$t('fixcancelDetails')">
            <b-form-textarea
              v-model="form.cancelDetails"
              :placeholder="$t('fixcancelDetailsinput')"
              rows="3"
              required
            />
          </b-form-group>
          <b-button
            variant="danger"
            @click="confirmCancel"
          >
            {{ $t('cancelconfirm') }}
          </b-button>
          <b-button
            variant="secondary"
            class="ml-1"
            @click="showCancelModal = false"
          >
            {{ $t('cancel') }}
          </b-button>
        </div>
      </b-modal>
    </b-modal>

    <!-- Popup ยืนยัน -->
    <b-modal
      v-model="showModalconfirmworker"
      :title="$t('confirmapprove')"
      hide-footer
    >
      <p>{{ $t('confirmdetails') }}</p>
      <div class="text-right">
        <b-button
          variant="secondary"
          @click="showModalconfirmworker = false"
        >
          {{ $t('cancel') }}
        </b-button>
        <b-button
          variant="primary"
          @click="confirmworker"
        >
          {{ $t('confirm') }}
        </b-button>
      </div>
    </b-modal>

    <!--model confirm-->
    <div
      v-if="isLoading"
      class="overlay"
    >
      <div class="loading-container">
        <b-spinner
          label="Loading..."
          class="spinner"
        />
        <p class="loading-text">
          {{ $t('loading') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import apiAdmin from '@/services/admin'
import apiAuth from '@/services/auth'
import { getRolesFromToken } from '@/services/JwtDecoder'
import apiUpdate from '@/services/update'
import emailservice from '@/services/emailservice'

export default {
  props: {
    show: Boolean,
    fix: {
      type: Object,
      default: () => ({}),
    },
    spareList: {
      type: Array,
      required: true,
      default: () => [],
    },
    expense: {
      type: [Array, Object],
      required: true,
      default: () => [],
      validator: value => Array.isArray(value) || typeof value === 'object',

    },
  },
  data() {
    return {
      selectedFile: null,
      imageUrls: [],
      imageUrlsDone: [],
      errorMessage: '',
      modalShow: this.show,
      imageModalShow: false,
      selectedImage: '',
      chatModalShow: false,
      chats: [],
      message: '',
      currentUserId: this.$store.getters.userId || null,
      roles: [],
      status: '',
      isLoading: false,
      isLoadingImg: false,
      isLoadingcancel: false,
      showCancelModal: false,
      files: [],
      filesdone: [],
      form: {
        cancelDetails: '',
      },
      maxStars: 5,
      showModalconfirmworker: false,
    }
  },

  computed: {
    displayExpensesList() {
      if (Array.isArray(this.expense) && this.expense.length > 0) {
        const filteredExpenses = this.expense.filter(item => item && item !== '')
        return filteredExpenses
      }
      if (this.expense && typeof this.expense === 'object' && Object.keys(this.expense).length > 0) {
        return [this.expense]
      }
      return []
    },
    totalCost() {
      if (this.expense && Array.isArray(this.expense)) {
        const total = this.expense.reduce((sum, item) => sum + (parseFloat(item.sum || (item.quantity * item.cost)) || 0), 0)
        return this.formatCurrencyCost(total)
      }
      return 0
    },
    totalSpareCost() {
      return this.spareList.reduce((total, item) => total + (item.spCost || 0), 0).toFixed(2)
    },

    expenseFields() {
      return [
        { key: 'expenseCateName', label: this.$t('expenseCateName') },
        { key: 'expenseSubcateName', label: this.$t('expenseSubcateName') },
        { key: 'quantity', label: this.$t('quantity') },
        { key: 'unit', label: this.$t('unit') },
        { key: 'cost', label: this.$t('expense') },
        { key: 'sum', label: this.$t('sum') },
        { key: 'note', label: this.$t('remark') },
      ]
    },
    spareFields() {
      return [
        { key: 'orderlist', label: this.$t('orderlist') },
        { key: 'list', label: this.$t('list') },
        { key: 'purchase', label: this.$t('orderbuy') },
        { key: 'quantity', label: this.$t('amount') },
        { key: 'cost', label: this.$t('cost') },
        { key: 'source', label: this.$t('sourcespare') },
        { key: 'detail', label: this.$t('remark') },
      ]
    },
    userId() {
      console.log('id', this.$store.getters.userId)
      return this.$store.getters.userId
    },
  },

  watch: {
    show(newVal) {
      this.modalShow = newVal
    },
    fix: 'fetchImages',
    expense() {
      this.scrollToBottom()
    },
  },

  created() {
    this.accessToken = localStorage.getItem('accessToken')
    this.roles = getRolesFromToken(this.accessToken)
  },
  async mounted() {
    this.scrollToBottom()
    await this.fetchImages()
  },

  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleImageClose() {
      this.selectedImage = ''
    },
    isSum(cost) {
      return cost === this.$t('sum')
    },

    formatCurrency(value) {
      if (isNaN(value)) return '0.00 ฿'
      return `${new Intl.NumberFormat('th-TH', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value)} ฿`
    },

    formatCurrencyCost(value) {
      if (isNaN(value)) return '0.00 ฿'
      return `${new Intl.NumberFormat('th-TH', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value)} ฿`
    },

    async fetchImages() {
      if (!this.fix || !this.fix.order) return

      const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || 'https://mns.gelogs.co.th/api/'

      this.isLoadingImg = true
      try {
        const response = await apiAdmin.get(`/images/${this.fix.order}`)
        // กรองเฉพาะไฟล์รูปภาพ
        this.imageUrls = response.data.filter(filePath => /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath))
          .map(filePath => `${apiBaseUrl}${filePath}`)
        // กรองไฟล์ที่ไม่ใช่รูปภาพ เช่น ไฟล์เอกสาร
        this.files = response.data.filter(filePath => !/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath))
          .map(filePath => `${apiBaseUrl}${filePath}`)
      } catch (error) {
        this.imageUrls = []
        this.files = []
      } finally {
        this.isLoadingImg = false
      }

      // โหลดภาพชุดที่สอง
      try {
        const responseDone = await apiAdmin.get(`/imagesDone/${this.fix.order}`)
        this.imageUrlsDone = responseDone.data.filter(filePath => /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath))
          .map(filePath => `${apiBaseUrl}${filePath}`)
        this.filesdone = responseDone.data.filter(filePath => !/\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filePath))
          .map(filePath => `${apiBaseUrl}${filePath}`)
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // console.clear()
        }
        this.imageUrlsDone = []
        this.filesdone = []
      } finally {
        this.isLoadingImg = false
      }
    },

    formatDate(dateString) {
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // ถ้าต้องการเวลาในรูปแบบ 24 ชั่วโมง
      }

      return new Date(dateString).toLocaleString('th-TH', options)
    },

    showImage(url) {
      this.selectedImage = url
      this.imageModalShow = true
    },

    async approve() {
      this.isLoading = true
      try {
        const fixData = {
          status: { id: 2 },
        }

        const workerEmails = await this.fetchWorkerEmails()
        if (!workerEmails || workerEmails.length === 0) {
          throw new Error('ไม่พบอีเมลผู้ดำเนินการซ่อม')
        }

        await this.sendEmailNotification(workerEmails, false)

        this.modalShow = false
        this.$emit('refresh')
      } catch (error) {
        console.error('Error approving:', error)
        this.errorMessage = 'เกิดข้อผิดพลาดในการอนุมัติ'
      } finally {
        this.isLoading = false
      }
    },

    async confirmworker() {
      this.isLoading = true
      try {
        await apiAuth.put(`/fixpdf/confirm/${this.fix.order}`)
        this.modalShow = false
        this.showModalconfirmworker = false
        this.$emit('refresh')
      } catch (error) {
        console.error('Error approving:', error)
        this.errorMessage = 'เกิดข้อผิดพลาดในการอนุมัติ'
      } finally {
        this.isLoading = false
      }
    },

    async fetchWorkerEmails() {
      try {
        const response = await apiAuth.post('/email/searchrolemail', { roleId: 5 })

        if (response.status === 200) {
          const emails = response.data
          if (Array.isArray(emails) && emails.length > 0) {
            return emails.map(email => email.trim())
          }
          throw new Error('No emails found in API response')
        }
        throw new Error('Failed to fetch worker emails')
      } catch (error) {
        console.error('Error fetching worker emails:', error)
        throw error
      }
    },

    async fetchEmails(userId) {
      if (!userId) {
        throw new Error('User ID is required')
      }

      try {
        const response = await apiAuth.post('/email/searchuser', { userId })
        if (response.status === 200) {
          const match = response.data.match(/\[([^\]]+)\]/)
          if (match && match[1]) {
            return match[1].split(',').map(email => email.trim())
          }
          throw new Error('No emails found in API response')
        }
        throw new Error('Failed to fetch approver emails')
      } catch (error) {
        console.error('Error fetching approver emails:', error)
        throw error
      }
    },

    async sendEmailNotification(emailData, isCancelled = false) {
      try {
        if (!emailData || emailData.length === 0) {
          throw new Error('Recipients list is empty')
        }

        const isTokenValid = emailservice.isTokenValid()
        if (!isTokenValid) {
          throw new Error('Please log in again to send emails')
        }

        const emailSubject = `รายละเอียดการแจ้งซ่อม(${this.fix.order ?? 'N/A'}) `

        const emailMessage = isCancelled
          ? `
        <p>เรียน <strong>ผู้แจ้งซ่อม</strong>,</p>
        <p>สถานะการแจ้งซ่อมของท่านได้ถูกยกเลิกแล้ว มีรายละเอียดดังนี้:</p>
      `
          : `
        <p>เรียน <strong>ผู้ดำเนินการซ่อม</strong>,</p>
        <p>ขอความอนุเคราะห์เพื่อดำเนินการซ่อมต่อไป มีรายละเอียดดังนี้:</p>
      `

        const emailTemplate = `
      <!DOCTYPE html>
      <html>
      <body>
        ${emailMessage}
        <ul>
          <li>หมายเลขแจ้งซ่อม: ${this.fix.order ?? 'N/A'}</li>
          <li>ผู้แจ้งซ่อม: ${this.fix.user.username ?? 'N/A'}</li>
          <li>แจ้งซ่อมเวลา: ${this.formatDate(this.fix.timefix)}</li>
          <li>หมวดหมู่ปัญหา: ${this.fix.category ? this.fix.category.nameCate : ''}</li>
          <li>หมวดหมู่ปัญหาย่อย: ${this.fix.subcategory ? this.fix.subcategory.name : ''}</li>
          <li>ชื่ออุปกรณ์: ${this.fix.device ? this.fix.device.deviceName : ''}</li>
          <li>รายละเอียด: ${this.fix.fixDetails?.[0]?.detail ?? 'N/A'}</li>
        </ul>
        <p>ขอแสดงความนับถือ</p>
      </body>
      </html>
    `
        await emailservice.sendEmailWithTemplate(emailData, emailTemplate, { subject: emailSubject })
      } catch (error) {
        console.error('Error sending email:', error)
        throw error
      }
    },

    async confirmCancel() {
      if (!this.fix || !this.fix.id) {
        this.errorMessage = 'ไม่สามารถลบการซ่อมได้: หมายเลขการซ่อมไม่ถูกต้อง'
        return
      }

      if (this.form.cancelDetails.trim() === '') {
        this.errorMessage = 'กรุณากรอกหมายเหตุในการยกเลิก'
        return
      }

      this.isLoading = true

      try {
        const dataToSend = {
          cancelDetails: this.form.cancelDetails,
          fixId: this.fix.id,
        }
        await apiAdmin.put(`/updateCancelDetails/${this.fix.id}`, dataToSend)

        const fixData = {
          status: { id: 5 },
        }
        await apiAdmin.put(`/cancel/${this.fix.id}`, fixData)

        let userEmails = []
        if (this.fix.user && this.fix.user.id) {
          try {
            userEmails = await this.fetchEmails(this.fix.user.id)
            console.log('Fetched user emails:', userEmails)
          } catch (error) {
            console.error('Error fetching user emails:', error)
            throw new Error('ไม่สามารถดึงข้อมูลอีเมลผู้ใช้ได้')
          }
        }

        if (userEmails && userEmails.length > 0) {
          try {
            await this.sendEmailNotification(userEmails, true)
          } catch (error) {
            console.error('Error sending cancellation email:', error)
            throw new Error('ไม่สามารถส่งอีเมลแจ้งเตือนได้')
          }
        }
        this.modalShow = false
        await this.$emit('refresh')
      } catch (error) {
        console.error('Error in cancel process:', error)
        this.errorMessage = `เกิดข้อผิดพลาดในการยกเลิก: ${error.message}`
      } finally {
        this.isLoading = false
      }
    },

    clearCancelDetails() {
      this.form.cancelDetails = ''
    },

    openChatModal() {
      this.currentUserId = this.$store.getters.userId || null
      console.log('user:', this.currentUserId)
      this.chatModalShow = true
      this.fetchChats().then(() => {
        this.$nextTick(() => {
          this.scrollToBottom()
        })
      })
    },
    clearChat() {
      this.chats = []
      this.message = ''
    },

    async fetchChats() {
      const response = await apiUpdate.get(`/chatGetfixId/${this.fix.id}`)
      this.chats = response.data
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },

    async sendMessage() {
      if (this.message.trim()) {
        try {
          await apiUpdate.post(`/chatAdd/${this.fix.id}`, {
            message: this.message,
            fix: { id: this.fix.id },
            user: { id: this.currentUserId },
          })
          this.message = ''
          this.fetchChats()
          this.scrollToBottom()
        } catch (error) {
          console.error('Error sending message:', error)
          this.errorMessage = 'เกิดข้อผิดพลาดในการส่งข้อความ'
        }
      } else {
        this.errorMessage = 'กรุณากรอกข้อความก่อนส่ง'
      }
    },

    formatDatechat(dateString) {
      return new Date(dateString).toLocaleTimeString('th-TH', {
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      })
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const messagesContainer = this.$refs.messages
        if (messagesContainer) {
          messagesContainer.scrollTop = messagesContainer.scrollHeight
        }
      })
    },
    async viewPdf() {
      try {
        const response = await apiAuth.get(`/fixpdf/fixId/${this.fix.id}/${this.fix.user.id}`, {
          responseType: 'blob',
        })
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
        window.open(url)
      } catch (error) {
        console.error('Error fetching the PDF:', error)
      }
    },

  },
}
</script>

<style scoped>

.showfiles {
  width: fit-content;
  max-width: 80%;
}

.form-container {
  display: flex; /* ใช้ Flexbox */
  gap: 20px; /* ระยะห่างระหว่างกล่อง */
  flex-wrap: wrap; /* ให้กล่องย่อเมื่อพื้นที่ไม่พอ */
}

.form-section {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #f9f9f9;
  flex: 1; /* ทำให้แต่ละกล่องขยายเต็มที่ */
  min-width: 300px; /* กำหนดความกว้างขั้นต่ำ */
  box-sizing: border-box; /* ให้ความสูงรวมของ box รวม padding และ border */
  white-space: nowrap;
}

.section-title {
  background-color: #4a6a8c;
  color: white;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 15px;
}

.b-form-group {
  margin-bottom: 15px;
  flex: 1 1 calc(50% - 1rem)
}

.img-thumbnail {
  max-width: 150px;
  max-height: 150px;
  cursor: pointer;
  transition: transform 0.2s;
}

.img-thumbnail:hover {
  transform: scale(1.05);
}

.loading-text {
  margin-top: 10px;
  font-size: 16px;
}
.b-spinner {
  color: white;
}
.loading-container {
  text-align: center;
  color: #fff;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.info-box {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  background-color: #f9f9f9;
  margin-top: 5px;
  max-height: 12vh;
  overflow-x: auto;

  height: 12vh;
  min-width: 20vw;
  min-height: 5vh;
  max-width: 30vw;
  width: 9vw;
  word-break: break-word;
  white-space: normal;

  @media (max-width: 720px) {
    width: 90%;
    max-width: 90%;
    min-width: 80%;
    min-height: 50px;
    padding: 15px;
  }
}

/* เอาไว้จัดหมวดหมู่ให้อยู่ในหมวดเดียวกัน */
.form-row {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.input-box{
  width: 200px;
  height: 35px;
}

/*chat btn*/
.chat-container {
  display: flex;
  flex-direction: column;
  height: 500px;
}

.messages {
  flex-grow: 1;
  overflow-y: auto;
  padding: 10px;
}

.my-message,
.other-message {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

.other-message {
  justify-content: flex-start;
}

.my-message {
  justify-content: flex-end;
}

.user-name {
  font-weight: bold;
}

.chat-bubble {
  max-width: 70%;
  padding: 10px;
  border-radius: 20px;
  margin: 5px;
  border: 1px solid #e0e0e0;
  background-color: #fff;
}

.my-message .chat-bubble {
  background-color: #dcf8c6;
}

.timestamp {
  font-size: 0.75em;
  color: #888;
}

.user-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.input-group {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

input {
  flex-grow: 1;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

button {
  margin-left: 5px;
  padding: 8px 12px;
}

.clickable-icon {
  cursor: pointer;
  margin-right: 10px;
}

.icon-large {
  font-size: 24px;
}

.messages {
  flex-grow: 1;
  overflow-y: auto;
  padding: 10px;
  max-height: 400px;
}

.table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* สำหรับ iOS */
}

</style>
